var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-line-flex"},[_c('p',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"round-btn",on:{"click":function($event){return _vm.editRawData()}}},[_c('i',{staticClass:"far fa-edit"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68fd8f64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/smallComponents/PageHeader.vue
// module id = null
// module chunks = 